import { useQuery } from "@tanstack/react-query";

import { getFinancialYear } from "api/generated/financial-years/financial-years";
import { FinancialYearView } from "api/generated/model";

export const FINANCIAL_YEAR_QUERY_KEY = "financial-year";

export const useFinancialYearQuery = (
    placeholderData: FinancialYearView | null
) =>
    useQuery({
        queryKey: [FINANCIAL_YEAR_QUERY_KEY],
        queryFn: async () => {
            const response = await getFinancialYear();
            return response.data;
        },
        placeholderData,
        retry: true,
    });
